import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { App } from "./App";
import { ApiError } from "@/lib/api";
import { useThemeStore } from "@/stores/themeStore";
import "@/styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying an auth or permission failure just burns rate limit.
        if (error instanceof ApiError) {
          if ([401, 403, 404, 409, 422].includes(error.status)) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

const ThemedToaster = () => {
  const resolved = useThemeStore((s) => s.resolved);
  return (
    <Toaster
      theme={resolved}
      position="top-right"
      closeButton
      richColors
      toastOptions={{ duration: 5000 }}
    />
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <ThemedToaster />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
